<template>
  <v-card elevation="0" class="vantaggi-card" @click="clicked">
    <v-flex class="d-flex" style="height:100%;">
      <v-avatar class="align-self-center" tile>
        <img src="/img/vantaggi-default-image.png" alt="Immagine vantaggi" />
      </v-avatar>
      <div class="flex-grow-1">
        <div>
          <v-card-title>
            <strong v-html="name"></strong>
          </v-card-title>
          <v-card-subtitle v-if="description">
            <template v-html="description" />
          </v-card-subtitle>
        </div>
        <v-spacer></v-spacer>

        <v-card-actions>
          <v-btn
            v-if="link"
            outlined
            x-small
            depressed
            color="primary"
            :to="link"
          >
            {{ btnLabel }}
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="isAssignable && userGiftCertificateId != null"
            x-small
            depressed
            outlined
            color="primary"
            @click="remove(userGiftCertificateId)"
          >
            Rimuovi
          </v-btn>
          <v-btn
            v-else-if="isAssignable"
            x-small
            depressed
            color="primary"
            @click="add"
          >
            Usa ora
          </v-btn>
        </v-card-actions>
      </div>
    </v-flex>
  </v-card>
</template>
<style scoped>
img.size-full {
  width: 100%;
}
.v-avatar {
  margin: 5px;
  margin-left: 15px;
  height: 65px !important;
  min-width: 65px !important;
  width: 65px !important;
}
.vantaggi-card {
  height: 100%;
  border-radius: 8px;
}
.v-card__title {
  font-size: 1.05rem;
  line-height: 1.2em;
  word-break: break-word;
}
.v-card__actions {
  justify-content: flex-end;
  margin-top: -10px;
}
.v-card__subtitle {
  line-height: 1.3em;
  padding-top: 6px;
}
</style>
<script>
import clickHandler from "~/mixins/clickHandler";
import giftCertificate from "@/components/gift/giftCertificate";

export default {
  name: "GiftCard",
  mixins: [clickHandler, giftCertificate]
};
</script>
